/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Next_Month_BlockedInputs */



/**
* | output |
* | --- |
* | "This is the current month. Later months have no closed periods yet." |
*
* @param {Partner_Billing_Board_Next_Month_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_next_month_blocked = /** @type {((inputs?: Partner_Billing_Board_Next_Month_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Next_Month_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dies ist der laufende Monat. Spätere Monate haben noch keine abgeschlossenen Zeiträume.")
	return /** @type {LocalizedString} */ ("This is the current month. Later months have no closed periods yet.")
});